import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";

import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Security = Loader(lazy(() => import("src/content/security")));

const securityRouters = [
  {
    path: "/",
    element: (
      <>
        <Helmet>
          <title>Güvenlik</title>
        </Helmet>
        <Security />
      </>
    ),
  },
];

export default securityRouters;
